import { Page } from "../components/ui.jsx";
import { LAUNCH } from "../data/launch.js";
import { LINKS } from "../data/site.js";

export default function Launch({ back }) {
  return (
    <Page back={back} eyebrow={LAUNCH.eyebrow} title={LAUNCH.title} intro={LAUNCH.intro}>
      {LAUNCH.blocks.map((b) => (
        <div key={b.h} className="block">
          <h3>{b.h}</h3>
          <p>{b.p}</p>
        </div>
      ))}
      <a className="card" href={LINKS.events} target="_blank" rel="noreferrer">
        <div className="name">
          <span>Event details & registration</span>
          <span className="arrow">→</span>
        </div>
        <div className="desc">Opens Church Center.</div>
      </a>
    </Page>
  );
}
